import React, { useCallback } from 'react';

import { ThreeDStockMenuCategoriesItemType } from './ThreeDStockMenuCategoriesItem.types';
import { CategoryID } from '../../../../../../categories/categoriesTypes';
import { IsDisabled } from '../../../../../../../types';

import { PureIconButtonHelper } from '../../../../../../../helpers/buttons/PureIconButtonHelper';

import { IconsEnum } from '../../../../../../../assets/icons/types';
import { PureButtonHelper } from '../../../../../../../helpers/buttons/PureButtonHelper';

interface ThreeDStockMenuCategoriesItemProps {
  category: ThreeDStockMenuCategoriesItemType;
  disabled?: IsDisabled;
  selectCategory: (id: CategoryID, hasChildrenCategories?: boolean) => void;
  hasChildrenCategories: boolean;
}

function ThreeDStockMenuCategoriesItem({
  category,
  disabled,
  selectCategory,
  hasChildrenCategories
}: ThreeDStockMenuCategoriesItemProps) {
  const handleClick = useCallback(() => {
    selectCategory(category.id, hasChildrenCategories);
  }, [category.id, hasChildrenCategories, selectCategory]);

  return (
    <li>
      {hasChildrenCategories ? (
        <PureIconButtonHelper
          className="flex flex-row-reverse justify-between w-full items-center px-4 py-1.5 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors duration-150 ease-out"
          dataGa={`${category.id}-category`}
          i18nText={category.localizedName}
          i18nTextClassName="text-md leading-6"
          icon={IconsEnum.CHEVRON_RIGHT}
          iconClassName="h-5 w-5 text-gray-500 dark:text-gray-400"
          disabled={disabled}
          onClick={handleClick}
        />
      ) : (
        <PureButtonHelper
          className="flex justify-between w-full items-center px-4 py-1.5 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors duration-150 ease-out"
          dataGa={`${category.id}-category`}
          i18nText={category.localizedName}
          i18nTextClassName="text-md leading-6"
          disabled={disabled}
          onClick={handleClick}
        />
      )}
    </li>
  );
}

export default ThreeDStockMenuCategoriesItem;
